import { fas } from '@awesome.me/kit-b4fd369ea4/icons';
import { SidenavUtils } from '@/common/utils/SideNavUtils';

const skdrSideNav = {
  id: 'skdr',
  displayName: 'Scheduler',
  role: 'SKDR_VIEW',
  icon: fas.faCalendarAlt,
  precedence: 99,
  children: [
    // Events Section
    {
      id: 'skdrEventMenu',
      displayName: 'Events',
      role: 'SKDR_EVENT_VIEW',
      icon: fas.faRss,
      precedence: 1,
      children: [
        { id: 'skdrEvent', displayName: 'All Events', role: 'SKDR_EVENT_VIEW', icon: fas.faRss, route: '/skdr/event', precedence: 2 },
        // TODO: AH, discuss routes below...
        // Putting the entity first in the route because EntityMgrContext gets Entity from url
        // Also, discuss state here
        { id: 'skdrEventRequests', displayName: 'My Requests', role: 'SKDR_EVENT_VIEW', icon: fas.faRss, route: '/skdr/event/pending-approvals', precedence: 3, state: { isApprover: false } },
        { id: 'skdrEventApprovals', displayName: 'Pending Approvals', role: 'SKDR_EVENT_VIEW', icon: fas.faRss, route: '/skdr/event/pending-approvals', precedence: 4, state: { isApprover: true } }
      ]
    },

    // Jobs Section
    {
      id: 'skdrJobMenu',
      displayName: 'Jobs',
      role: 'SKDR_JOB_VIEW',
      icon: fas.faPlayCircle,
      precedence: 5,
      children: [
        { id: 'skdrApprJob', displayName: 'Approval Routes', role: 'SKDR_JOB_VIEW', icon: fas.faLink, route: '/skdr/job/appr', precedence: 6 },
        { id: 'skdrExportJob', displayName: 'Export Jobs', role: 'SKDR_JOB_VIEW', icon: fas.faArrowRight, route: '/skdr/job/export', precedence: 7 },
        { id: 'skdrGenJob', displayName: 'General Jobs', role: 'SKDR_JOB_VIEW', icon: fas.faCog, route: '/skdr/job', precedence: 8 },
        { id: 'skdrSched', displayName: 'Schedules', role: 'SKDR_SCHED_VIEW', icon: fas.faCalendar, route: '/skdr/sched', precedence: 10 }
      ]
    },

    // Runs Section
    { id: 'skdrRun', displayName: 'Runs', role: 'SKDR_RUN_VIEW', icon: fas.faRedo, route: '/skdr/run', precedence: 11 },

    // Add common menus (only including 'system')
    ...SidenavUtils.commonMenus('skdr', ['system'])
  ]
};

export default skdrSideNav;
